module.exports = __webpack_public_path__ + "img/angle_right_small.b55b156b.svg";